import { useTranslation } from "react-i18next";
import workerAvatars from "@/assets/worker-avatars.png";

const TrustedSection = () => {
  const { t } = useTranslation();
  
  const stats = [{
    value: "+15%",
    labelKey: "trusted.revenue",
    company: "Pro Builders",
    descriptionKey: "trusted.stats.proBuildersDesc"
  }, {
    value: "x2",
    labelKey: "trusted.retention",
    company: "AHC",
    descriptionKey: "trusted.stats.ahcDesc"
  }, {
    value: "50.000$",
    labelKey: "trusted.saved",
    company: "Reliant Roofing",
    descriptionKey: "trusted.stats.reliantDesc"
  }, {
    value: "15",
    valueUnit: "h/week",
    labelKey: "trusted.saved",
    company: "BK Restoration",
    descriptionKey: "trusted.stats.bkRestorationDesc"
  }];

  return <section className="bg-background py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Main content */}
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-start">
          {/* Left column - Headline */}
          <div className="lg:col-span-4 space-y-6">
            <h2 className="feature-trust-heading text-2xl font-bold leading-[1.3] text-features-foreground sm:text-3xl lg:text-4xl">
              {t('trusted.h2')}
            </h2>
            
            <p className="text-features-foreground/60 text-base">
              {t('trusted.builtFor')}
            </p>

            {/* Avatars with worker photos */}
            <div className="flex -space-x-2">
              
            </div>
          </div>

          {/* Right column - Stats cards */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {stats.map(stat => <div key={stat.company} className="relative bg-features-foreground/5 rounded-2xl p-6 lg:p-8 text-center overflow-hidden h-[240px] sm:h-[320px] flex flex-col">
                {/* Subtle brick pattern */}
                <div className="absolute inset-0 opacity-[0.03]">
                  <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <defs>
                      <pattern id="brick" width="20" height="10" patternUnits="userSpaceOnUse">
                        <rect width="19" height="9" fill="none" stroke="currentColor" strokeWidth="0.5" />
                      </pattern>
                    </defs>
                    <rect width="100" height="100" fill="url(#brick)" />
                  </svg>
                </div>

                {/* Top section - value/label */}
                <div className="relative h-[100px] flex flex-col justify-center shrink-0">
                  <span className="homepage-metric-value text-4xl lg:text-5xl font-black text-features-foreground">
                    {stat.value}
                    {stat.valueUnit && <span className="text-2xl lg:text-3xl font-bold ml-1">{stat.valueUnit}</span>}
                  </span>
                  <span className="homepage-stat-label block text-blue-500 font-bold tracking-wider mt-1 uppercase text-xl lg:text-2xl">
                    {t(stat.labelKey)}
                  </span>
                </div>
                
                {/* Middle section - company name (fixed position) */}
                <div className="relative shrink-0 py-3">
                  <p className="font-bold text-features-foreground text-base lg:text-lg">
                    {stat.company}
                  </p>
                </div>
                
                {/* Bottom section - description (fills remaining space) */}
                <div className="relative flex-1 flex items-start">
                  <p className="text-features-foreground/70 text-sm lg:text-base leading-relaxed">
                    {t(stat.descriptionKey)}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default TrustedSection;
